import { render, staticRenderFns } from "./StaffEditor.vue?vue&type=template&id=8d7d236e&lang=pug&"
import script from "./StaffEditor.vue?vue&type=script&lang=js&"
export * from "./StaffEditor.vue?vue&type=script&lang=js&"
import style0 from "./StaffEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports